import styled, { css } from 'styled-components';
import { LAYOUT, media } from '../../../../styles/themes/constants';

interface HeaderProps {
  $isTwoColumnsLayout: boolean;
}

export default styled.div<HeaderProps>`
  flex: 1;
  padding: 16px; /* Уменьшаем внутренние отступы */
  overflow: auto;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  margin: 0;
  box-sizing: border-box;
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px; /* Уменьшаем ширину скроллбара */
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    
    &:hover {
      background: rgba(0, 0, 0, 0.15);
    }
  }
`;
